import {
  GroupLocator,
  TeamsMeetingLinkLocator,
} from "@azure/communication-calling";
import { CommunicationUserIdentifier } from "@azure/communication-common";
import React, { useEffect, useState } from "react";
import { initializeIcons, Spinner } from "@fluentui/react";
import { HomeScreen } from "../views/HomeScreen";
import { CallError } from "../views/CallError";
import { CallScreen } from "../views/CallScreen";
import { EndCall } from "../views/EndCall";
import {
  navigateToHomePage,
  getTeamsLinkFromUrl,
  getGroupIdFromUrl,
} from "../utils/AppUtils"; //acsuserId, groupId, userAccessToken,
import { useGlobalState } from "../utils/GlobalState";
import { TokenService } from "../services/token.service";
import { UserService } from "../services/user.service";
import { useMsal } from "@azure/msal-react";
import configData from "../config.json";
import { ConfigData } from "../models/config";
import { ExaminerService } from "../services/examiner.service";
import { getAccessToken } from "../utils/AuthUtils";
const config = configData as ConfigData;

initializeIcons();

type AppPages = "home" | "call" | "endCall";

const webAppTitle = document.title;

const ACSHelper = (): JSX.Element => {
  const { instance, accounts, inProgress } = useMsal();
  const [page, setPage] = useState<AppPages>("home");
  // User credentials to join a call with - these are retrieved from the server

  const [token, setToken] = useState<string>();
  const [userId, setUserId] = useState<CommunicationUserIdentifier>();
  const [userCredentialFetchError, setUserCredentialFetchError] =
    useState<boolean>(false);

  // Call details to join a call - these are collected from the user on the home screen
  const [callLocator, setCallLocator] = useState<
    GroupLocator | TeamsMeetingLinkLocator
  >();
  const [groupCallLocator, setGroupCallLocator] = useState<GroupLocator>();
  const [displayName, setDisplayName] = useState<string>("");
  const [accessToken, setAccessToken] = useState("");
  const [courseName, setCourseName] = useState<string>("");
  const [meetingId, setMeetingId] = useState("");
  const { state, setState } = useGlobalState();

  const tokenService = new TokenService(instance);
  const userService = new UserService(instance);
  const examinerService = new ExaminerService(instance);

  const loginRequest = {
    scopes: [config.API_SCOPE],
  };

  // function RequestAccessToken() {
  //   const request = {
  //       ...loginRequest,
  //       account: accounts[0]
  //   };

  //   // Silently acquires an access token which is then attached to a request for Microsoft Graph data
  //   instance.acquireTokenSilent(request).then((response) => {
  //       setAccessToken(response.accessToken);
  //       localStorage.setItem("accessToken", response.accessToken);
  //       setState((prev) => {
  //         return  { ...prev, accessToken: response.accessToken };
  //       });
  //       PopulateExamDetail();
  //       generateSession();
  //   }).catch((e) => {
  //       instance.acquireTokenPopup(request).then((response) => {
  //           setAccessToken(response.accessToken);
  //           localStorage.setItem("accessToken", response.accessToken);
  //           PopulateExamDetail();
  //           generateSession();
  //           setState((prev) => {
  //             return  { ...prev, accessToken: response.accessToken };
  //           });
  //       });
  //   });
  // }

  useEffect(() => {
    // RequestAccessToken();

    const initialise = async () => {
      try {
        const token = await getAccessToken(instance, loginRequest);
        console.log(token);
        setState((prev) => {
          return { ...prev, accessToken: token };
        });
        PopulateExamDetail();
        generateSession();
      } catch (error) {
        console.log(error);
        setState((prev) => {
          return { ...prev, accessToken: token };
        });
        PopulateExamDetail();
        generateSession();
      }
    };

    initialise();
  }, [instance]);

  function PopulateMeetingId() {
    let id = localStorage.getItem("meetingId");
    if (!id) {
      id = sessionStorage.getItem('incomingMeetingId') || null;
      if (id) {
        try { localStorage.setItem('meetingId', id); } catch (e) {}
      }
    }
    if (id) {
      setMeetingId(id);
      setState((prev) => {
        return { ...prev, meetingId: id! };
      });
    }
  }

  function PopulateExamDetail() {
    let id = localStorage.getItem("meetingId") || sessionStorage.getItem('incomingMeetingId');
    if (!id) {
      // If meetingId is not present yet, wait for the incomingMeetingId event
      const handler = (e: any) => {
        try {
          const m = (e && e.detail) || sessionStorage.getItem('incomingMeetingId');
          if (!m) return;
          try { localStorage.setItem('meetingId', m); } catch (e) {}
          examinerService.getExamDetails(m).then((ex) => {
            setCourseName(ex.courseName);
            setState((prev) => ({ ...prev, examDetails: ex }));
          }).catch((err) => {
            console.error('Failed to fetch exam details for meetingId', m, err);
          });
        } finally {
          window.removeEventListener('incomingMeetingId', handler);
        }
      };

      window.addEventListener('incomingMeetingId', handler);
      return;
    }

    examinerService.getExamDetails(id).then((e) => {
      setCourseName(e.courseName);
      setState((prev) => {
        return { ...prev, examDetails: e };
      });
    }).catch((err) => {
      console.error('Failed to fetch exam details for meetingId', id, err);
    });
  }

  // Run once at mount to populate any meetingId that was captured earlier
  useEffect(() => {
    PopulateMeetingId();
  }, []);

  function generateSession() {
    userService.deleteUser().then(() => {
      userService
        .createUser()
        .then(() => {
          tokenService
            .fetchTokenResponse()
            .then((response) => {
              setToken(response.token);
              setUserId({ communicationUserId: response.user.id });
              setState((prev) => {
                return {
                  ...prev,
                  acsToken: response.token,
                  acsUserId: response.user.id,
                };
              });
            })
            .catch((error) => {
              console.error(error);
              setUserCredentialFetchError(true);
            });
        })
        .catch((e) => {
          setUserCredentialFetchError(true);
        });
    });
    setGroupCallLocator(groupCallLocator);
    setCallLocator({ groupId: state.meetingId! });
  }

  // const testClick = () => {
  //   examinerService.pingTest().then((response) => {
  //     console.log(response);
  //   });
  // };

  switch (page) {
    case "home": {
      return (
        <>
          {/* <button onClick={testClick}>Test</button> */}
          <HomeScreen
            startCallHandler={(callDetails) => {
              setDisplayName(callDetails.displayName);
              const callLocator = callDetails.teamsLink ||
                getTeamsLinkFromUrl() ||
                getGroupIdFromUrl() || { groupId: state.meetingId! };
              setCallLocator(callLocator);
              setPage("call");
            }}
          />
        </>
      );
    }
    case "endCall": {
      document.title = `end call - ${webAppTitle}`;
      return (
        <EndCall
          rejoinHandler={() => setPage("call")}
          homeHandler={navigateToHomePage}
        />
      );
    }
    case "call": {
      if (userCredentialFetchError) {
        document.title = `error - ${webAppTitle}`;
        return (
          <CallError
            title="Error getting user credentials from server"
            reason="Ensure the server is running."
            rejoinHandler={() => setPage("call")}
            homeHandler={navigateToHomePage}
          />
        );
      }

      if (!token || !userId || !displayName || !callLocator) {
        document.title = `credentials - ${webAppTitle}`;
        return (
          <Spinner
            label={"Getting user credentials from server"}
            ariaLive="assertive"
            labelPosition="top"
          />
        );
      }
      return (
        <CallScreen
          token={token}
          userId={userId}
          groupId={state.meetingId!}
          displayName={"Examiner"}
          callLocator={callLocator}
          onCallEnded={() => setPage("endCall")}
          webAppTitle={webAppTitle}
          onParticipantsJoined={() => {}}
        />
      );
    }
    default:
      document.title = `error - ${webAppTitle}`;
      return <>Invalid page</>;
  }
};

export default ACSHelper;
